import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Loader from "../../../common/loader";
import { formateDate, removeSpecialCharacter } from "../../../../../utils/commonfunction";
import { useTranslation } from "react-i18next";
// import $ from "jquery";
import { UserReportDetails } from "../../../services/reports.sevices";
import Breadcrums from "../../../common/breadcrumbs";
import { Placeholder } from "rsuite";

const BabeReportsView = (props) => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const params = useParams();
    const [loader, setLoader] = useState(true);
    const [showdefault, setShowDefault] = useState({});

    const breadcrumbs = [
        { title: t("sidebar_link_dashboard"), url: "/admin/dashboard" },
        {
            title: "Babe Reports",
            url: "/admin/reports/babe-reports/list/1",
        },
        { title: t("btn_view"), url: "" },
    ];

    useEffect(() => {
        UserReportDetails(params._id)
            .then((response) => {
                setTimeout(() => setLoader(false), 500)
                setShowDefault(response && response.data ? response.data : []);
            })
            .catch((error) => {
                setTimeout(() => setLoader(false), 500)
                console.log("error=====>", error);
            });
    }, [params._id]);

    return (
        <>
            <Breadcrums data={breadcrumbs} />
            <div className="row row-sm">
                <div className="col-lg-12 col-md-12 animation_fade">
                    <div className="card custom-card">
                        <div className="card-body">
                            <div>
                                <h6 className="main-content-label mb-3">{t("btn_view") + " " + t("User Reports")}</h6>
                            </div>
                            {!loader ? (
                                <div className="row">
                                    {showdefault && Object.keys(showdefault).length > 0 ? (<div className="col-lg-12 form-group">
                                        <table
                                            id="simple-table"
                                            className="table  table-bordered table-hover"
                                        >
                                            <tbody>
                                                <tr>
                                                    <th>{t("label_profile_image")}</th>
                                                    <td>
                                                        <img
                                                            src={
                                                                showdefault && showdefault.profile_image
                                                                    ? showdefault.profile_image
                                                                    : "N/A"
                                                            }
                                                            alt="profile"
                                                            style={{ height: "100px" }}
                                                        />
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <th>{t("label_name")}</th>
                                                    <td className="text-capitalize">
                                                        {showdefault && showdefault.name
                                                            ? showdefault.name
                                                            : "N/A"}
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <th>{t("label_email")}</th>
                                                    <td>
                                                        {showdefault && showdefault.email
                                                            ? showdefault.email
                                                            : "N/A"}
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <th>{t("Role")}</th>
                                                    <td className="text-capitalize">
                                                        {showdefault && showdefault.role && showdefault.role
                                                            ? <span className="badge badge-success">{removeSpecialCharacter(showdefault.role)}</span>
                                                            : "N/A"}
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <th>{t("label_phone_number")}</th>
                                                    <td>
                                                        {showdefault && showdefault?.phone_number
                                                            ? showdefault.phone_number
                                                            : "N/A"}
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <th>{t("list_heading_created_date")}</th>
                                                    <td>
                                                        {showdefault && showdefault.createdAt
                                                            ? formateDate(showdefault.createdAt)
                                                            : "N/A"}
                                                    </td>
                                                </tr>

                                            </tbody>
                                        </table>
                                    </div>) : <div className="row" ><p className="text-center">{t('label_no_data_found')}</p> </div>}
                                </div>
                            ) : (
                                <Placeholder.Paragraph className="w-100 admin-placeholder" rowHeight={30} rowSpacing={5} active={true} rows={7} />
                            )}
                            <div className="mt-5 back-button">
                                <button
                                    className="btn ripple btn-dark"
                                    type="button"
                                    onClick={() =>
                                        navigate("/admin/reports/babe-reports/list/1")
                                    }
                                >
                                    <i className="ace-icon-solid ion-arrow-return-left bigger-110 mx-1"></i>
                                    {t("btn_back")}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default BabeReportsView;
